export const GRADIENT_PRESETS: Record<string, string[]> = {
  roygbiv: ['#ff0000', '#ff7f00', '#ffff00', '#00ff00', '#0000ff', '#4b0082', '#9400d3'],
  viridis: ['#440154', '#414487', '#2a788e', '#22a884', '#7ad151', '#fde725'],
  magma:   ['#000004', '#3b0f70', '#8c2981', '#de4968', '#fe9f6d', '#fcfdbf'],
  cividis: ['#00224e', '#35456c', '#666970', '#948e77', '#c7b06b', '#fee838'],
  ice:     ['#03045e', '#0077b6', '#00b4d8', '#90e0ef', '#caf0f8'],
  ember:   ['#03071e', '#6a040f', '#dc2f02', '#f48c06', '#ffba08'],
  terrain: ['#2b3a1f', '#5c7a3d', '#a3b565', '#d9c78e', '#f2efe6'],
  mono:    ['#000000', '#ffffff'],
  twostep: ['#1b3b6f', '#f5f5f5', '#a30b37'],
};
